<template>
    <div id="suivi-de-connexion">
        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :withFilters="true" :filterComponent="AgGridDateFilterLastWeek" :agGrid="agGrid"
                    pageTitle="Suivi de connexion" @refresh="loadData" @filterClicked="filterClicked" />
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import AgGridDateFilterLastWeek from "@/views/components/ag-grid/AgGridDateFilterLastWeek.vue";

export default {
    components: {
        AgGrid,
    },
    data() {
        const today = new Date();
        const lastWeek = new Date();
        lastWeek.setDate(today.getDate() - 7);
        return {
            AgGridDateFilterLastWeek: AgGridDateFilterLastWeek,
            dateDebut: lastWeek.toISOString().split('T')[0],
            dateFin: today.toISOString().split('T')[0],
            showLoading: true,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Utilisateur",
                        field: "name",
                    },
                    {
                        headerName: "Date de connexion",
                        field: "loginDate",
                        valueGetter(tr) {
                            if (tr.data.loginDate != null)
                                return tr.data.loginDate.substring(0, 10) + " | " + tr.data.loginDate.substring(11, 16);
                            return '';
                        },
                    },
                    {
                        headerName: "Date de déconnexion",
                        field: "logoutDate",
                        valueGetter(tr) {
                            if (tr.data.logoutDate != null)
                                return tr.data.logoutDate.substring(0, 10) + " | " + tr.data.logoutDate.substring(11, 16);
                            return '';
                        },
                    },
                ],
                rows: []
            },
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        filterClicked(obj) {
            this.dateDebut = obj.sDate;
            this.dateFin = obj.eDate;
            this.loadData();
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.get("usertrack", {
                params: { dateDebut: this.dateDebut, dateFin: this.dateFin }
            }).catch(() => { this.showLoading = false; });
            this.agGrid.rows = response.data.reverse();
            this.showLoading = false;
        },
    }
}
</script>

<style lang="scss"></style>
